import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';

import { Button, IconButton, LbInput, TitleWithDescription } from '@infoods/lifebase-ui';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';

import { FormFieldsGrid } from '../../../FormFieldsGrid/FormFieldsGrid';
import { ChallengeFormValues } from '../../../../../interfaces/ChallengeFormValues';

import classes from './DivisionsSection.module.scss';
import { Mode } from '../../../../../../general-types';
import { validateWhitespace } from '../../../../../../shared/utils/reactHookFormUtils';

type DivisionsSectionProps = {
  mode: Mode;
};

export const DivisionsSection = ({ mode }: DivisionsSectionProps) => {
  const { control } = useFormContext<ChallengeFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'about.divisions',
  });

  const handleAddDivision = () => {
    append({ name: '' });
  };

  const isViewMode = mode === 'VIEW';

  return (
    <FormFieldsGrid customPadding className={classes.container} mode={mode}>
      <TitleWithDescription
        title="Divisions"
        titleFont="body-14-bold"
        description="Create a division if you want to group participants by specific characteristics (e.g., HR, Finance Dept, Team A, Team B)."
      />
      {isViewMode ? (
        <div className={classes.viewModeDivisionColumn}>
          {fields.length > 0 ? fields.map((field) => field.name).join(', ') : '—'}
        </div>
      ) : (
        <div className={classes.divisionColumn}>
          {fields.map((field, index) => (
            <div key={field.id} className={classes.divisionRow}>
              <LbInput
                control={control}
                variant="standard"
                size="small"
                name={`about.divisions.${index}.name`}
                label={`Division ${index + 1}`}
                rules={{
                  required: 'Division Name is required',
                  validate: { validateWhitespace },
                }}
              />
              <IconButton onClick={() => remove(index)} color="tertiary">
                <CancelIcon />
              </IconButton>
            </div>
          ))}
          <Button
            variant="text"
            color="primary"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleAddDivision}
          >
            Add New Division
          </Button>
        </div>
      )}
    </FormFieldsGrid>
  );
};
